import React from 'react';

export default function DeleteModal({ isOpen, onClose, onConfirm, itemName }) {
    if (!isOpen) return null;

    return (
        <div className="modal-overlay">
            <div className="modal-content">
                <h3>Bekreft sletting</h3>
                <p>Er du sikker på at du vil slette {itemName}?</p>
                <div className="modal-actions">
                    <button 
                        className="cancel-button"
                        onClick={onClose}
                    >
                        Avbryt
                    </button>
                    <button 
                        className="delete-button"
                        onClick={onConfirm}
                    >
                        Slett
                    </button>
                </div>
            </div>
        </div>
    );
} 